import React from 'react';

import type { ContainerComponent } from '../../common/types/Common';

const HandleRedirectFromNotification: ContainerComponent = ({ children }) => {
    return <>{children}</>;
};

export default HandleRedirectFromNotification;
